/**
 * Safari/iOS < 15.4 fire ResizeObserver callbacks with entries that lack
 * `borderBoxSize`. react-window@2 reads `entry.borderBoxSize[0].blockSize`
 * unconditionally (used by manage-children table, the virtual list, the MF
 * Select and the feed post composer), which throws
 * `undefined is not an object (evaluating 't[0]')` on those browsers
 * (APP-PRODUCTION-5SE).
 *
 * Backfill `borderBoxSize` from the entry's target element so those reads work
 * on old WebKit. No-op when the API is already supported, or absent (SSR/tests).
 */
export const setupResizeObserverBorderBoxSize = (): void => {
    if (typeof ResizeObserverEntry === 'undefined') {
        return;
    }

    if ('borderBoxSize' in ResizeObserverEntry.prototype) {
        return;
    }

    Object.defineProperty(ResizeObserverEntry.prototype, 'borderBoxSize', {
        configurable: true,
        get(this: ResizeObserverEntry): ReadonlyArray<ResizeObserverSize> {
            // getBoundingClientRect is border-box, matching `blockSize`/`inlineSize` in horizontal writing modes.
            const {width, height} = this.target.getBoundingClientRect();

            return [{inlineSize: width, blockSize: height}];
        },
    });
};
